import Api from "../../../app/apiRequest";
import BaseResponse from "../../../app/BaseResponse";
import StockQueryModel from "../models/StockQueryModel";
import StockModel from "../models/StockModel";
import StockStatiticModel from "../models/StockStatiticModel";

export interface SearchStockParam {
    pageSize: number,
    query: StockQueryModel
}

export interface GetStockByIdParam {
    id: string,
}

export interface DeleteStockByIdParam {
    id: string,
}

const StockApi = {
    GetByItem(param: StockQueryModel) {
        return Api.post<StockQueryModel, BaseResponse<StockModel[]>>("/api/Stock/GetByItem", param);
    },
    GetStockStatitics() {
        return Api.get<unknown, BaseResponse<StockStatiticModel[]>>("/api/Stock/GetStockStatitics", null);
    },
    Save(param: StockModel) {
        return Api.post<StockModel, BaseResponse<StockModel>>("/api/Stock/Save", param);
    },
    GetById(param: GetStockByIdParam) {
        return Api.get<GetStockByIdParam, BaseResponse<StockModel>>("/api/Stock/GetById", param);
    },
    Delete(param: DeleteStockByIdParam) {
        return Api.post<DeleteStockByIdParam, BaseResponse<StockModel>>("/api/Stock/Delete", param);
    },
    GetStockItems() {
        return Api.get<unknown, BaseResponse<string[]>>("/api/Stock/GetStockItems", null);
    },
};
export default StockApi;